import { createContext } from 'react'

export const PageThemeContext = createContext({
  theme: 'main',
  setTheme: () => {},
  themeObj: {},
})
